/* DHC v1030 — conversion optimization layer */
(function(){
  'use strict';
  function money(cents){
    try{return new Intl.NumberFormat(document.documentElement.lang||'en-US',{style:'currency',currency:(window.Shopify&&Shopify.currency&&Shopify.currency.active)||'USD'}).format((Number(cents)||0)/100);}
    catch(e){return '$'+((Number(cents)||0)/100).toFixed(2);}
  }
  function syncPdp(scope){
    (scope||document).querySelectorAll('.dhc-pdp-v931').forEach(function(pdp){
      if(pdp.dataset.dhcV1030Ready==='1') return;
      pdp.dataset.dhcV1030Ready='1';
      var form=pdp.querySelector('[data-dhc-product-form]');
      if(!form) return;
      var select=form.querySelector('[data-dhc-variant-select]');
      var mainPrice=pdp.querySelector('[data-dhc-product-price]');
      var mainCompare=pdp.querySelector('[data-dhc-product-compare]');
      var saleBadge=pdp.querySelector('[data-dhc-sale-badge]');
      var inventory=pdp.querySelector('[data-dhc-product-inventory]');
      var addBtn=form.querySelector('[data-dhc-pdp-add]');
      var sticky=document.querySelector('[data-dhc-sticky-atc]');
      var stickyPrice=sticky&&sticky.querySelector('[data-dhc-sticky-price]');
      var stickyAdd=sticky&&sticky.querySelector('[data-dhc-sticky-add]');
      function refreshPrice(){
        if(!select) return;
        var opt=select.options[select.selectedIndex];
        if(!opt) return;
        var cents=Number(opt.dataset.price||0);
        var compare=Number(opt.dataset.compare||0);
        if(cents && mainPrice) mainPrice.textContent=money(cents);
        if(cents && stickyPrice) stickyPrice.textContent=money(cents);
        var available=!opt.disabled && String(opt.dataset.available||'true')!=='false';
        if(mainCompare){
          if(compare>cents){mainCompare.textContent=money(compare);mainCompare.hidden=false;}
          else{mainCompare.textContent='';mainCompare.hidden=true;}
        }
        if(saleBadge) saleBadge.hidden=!(compare>cents);
        if(inventory){
          inventory.innerHTML=available?'<span class="is-in">● In stock</span>':'<span class="is-out">● Out of stock</span>';
        }
        if(addBtn) addBtn.disabled=!available;
        if(stickyAdd) stickyAdd.disabled=!available;
      }
      if(select){select.addEventListener('change',refreshPrice);refreshPrice();}
      if(stickyAdd){
        stickyAdd.addEventListener('click',function(){
          var original=form.querySelector('[data-dhc-pdp-add]');
          if(original && !original.disabled){
            stickyAdd.disabled=true;stickyAdd.textContent='ADDING…';
            original.click();
            window.setTimeout(function(){stickyAdd.disabled=false;stickyAdd.textContent='ADD TO CART';},1700);
          }
        });
      }
      var observerTarget=form.querySelector('[data-dhc-pdp-status]');
      if(observerTarget && stickyAdd){
        new MutationObserver(function(){
          var msg=(observerTarget.textContent||'').trim();
          if(/Added to cart/i.test(msg)){stickyAdd.textContent='ADDED ✓';window.setTimeout(function(){stickyAdd.textContent='ADD TO CART';},1600);}
        }).observe(observerTarget,{childList:true,subtree:true,characterData:true});
      }
    });
  }
  function enhanceProgress(scope){
    (scope||document).querySelectorAll('[data-dhc-free-shipping-progress]').forEach(function(w){
      var total=Number(w.dataset.total||0), threshold=Number(w.dataset.threshold||5900);
      var bar=w.querySelector('.dhc-cart-progress-v1030__track span');
      if(bar) bar.style.width=Math.max(0,Math.min(100,total/threshold*100))+'%';
    });
  }
  function enhanceDrawer(){
    var drawer=document.querySelector('[data-cart-drawer]');
    if(!drawer || drawer.dataset.dhcV1030Progress==='1') return;
    drawer.dataset.dhcV1030Progress='1';
    var mo=new MutationObserver(function(){
      var ship=drawer.querySelector('.dhc-cart-drawer__shipping');
      if(!ship || ship.previousElementSibling&&ship.previousElementSibling.matches('[data-dhc-free-shipping-progress]')) return;
      fetch(((window.Shopify&&Shopify.routes&&Shopify.routes.root)||'/')+'cart.js',{headers:{Accept:'application/json'}})
        .then(function(r){return r.json()}).then(function(cart){
          var threshold=5900,total=Number(cart.total_price||0);
          var wrap=document.createElement('div');wrap.className='dhc-cart-progress-v1030';wrap.dataset.dhcFreeShippingProgress='';wrap.dataset.total=String(total);wrap.dataset.threshold=String(threshold);
          var track=document.createElement('div');track.className='dhc-cart-progress-v1030__track';var span=document.createElement('span');span.style.width=Math.max(0,Math.min(100,total/threshold*100))+'%';track.appendChild(span);wrap.appendChild(track);
          ship.parentNode.insertBefore(wrap,ship);
        }).catch(function(){});
    });
    mo.observe(drawer,{childList:true,subtree:true});
  }
  function boot(scope){syncPdp(scope||document);enhanceProgress(scope||document);enhanceDrawer();}
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',function(){boot(document)},{once:true}); else boot(document);
  document.addEventListener('shopify:section:load',function(e){boot(e.target)});
  document.addEventListener('dhc:cart:updated',function(){window.setTimeout(function(){enhanceProgress(document)},100)});
})();
